import { useMemo } from 'react';

import { useIncidents } from '@hooks/incidents';

/** Utility hook for obtaining an incident instance */
export const useIncident = (incidentId: string | undefined) => {
  const { incidents, ...rest } = useIncidents();

  return useMemo(
    () => ({
      incident: incidents?.find(
        (incident) => incident.incidentId === incidentId
      ),
      ...rest,
    }),
    [incidentId, incidents]
  );
};
